import { render, staticRenderFns } from "./ProducerCardComponent.vue?vue&type=template&id=5a8d0848&scoped=true"
import script from "./ProducerCardComponent.vue?vue&type=script&lang=js"
export * from "./ProducerCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8d0848",
  null
  
)

export default component.exports